"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_class_component_1 = require("vue-class-component");
var vue_property_decorator_1 = require("vue-property-decorator");
var moment = require("moment");
var decorators_1 = require("../../decorator/decorators");
var config_1 = require("../../dic/config");
var consent_repository_1 = require("../../repositories/consent.repository");
var consent_model_1 = require("../../model/consent.model");
var Type_vue_1 = require("../campaign/Type.vue");
var Flag_vue_1 = require("../campaign/Flag.vue");
var State_vue_1 = require("../campaign/State.vue");
var vuex_class_1 = require("vuex-class");
var layoutModule = vuex_class_1.namespace('layout');
var CROP_HEIGHT_THRESHOLD = 1500;
var STATUS_COLORS = {
    granted: 'green',
    expired: 'grey',
    withdrawn: 'red',
    none: 'grey'
};
var ConsentListComponent = (function (_super) {
    __extends(ConsentListComponent, _super);
    function ConsentListComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.result = null;
        _this.identifier = { type: 'email', value: '' };
        _this.channels = consent_model_1.ADVERTISER_FACING_CHANNELS;
        _this.selectedChannels = __spread(consent_model_1.ADVERTISER_FACING_CHANNELS);
        _this.imageHeights = {};
        _this.error = null;
        return _this;
    }
    Object.defineProperty(ConsentListComponent.prototype, "visibleChannels", {
        get: function () {
            var _this = this;
            return consent_model_1.ADVERTISER_FACING_CHANNELS.filter(function (channel) { return _this.selectedChannels.indexOf(channel) > -1; });
        },
        enumerable: false,
        configurable: true
    });
    ConsentListComponent.prototype.mounted = function () {
        this.load();
    };
    ConsentListComponent.prototype.onRouteChange = function () {
        this.load();
    };
    ConsentListComponent.prototype.load = function () {
        this.result = null;
        this.identifier = {
            type: this.$route.params.type,
            value: this.$route.params.identifier
        };
        this.search();
    };
    ConsentListComponent.prototype.search = function () {
        var _this = this;
        this.showProgressBar();
        this.error = null;
        this.consentRepository
            .search(this.identifier)
            .then(function (result) {
            _this.result = result;
            _this.hideProgressBar();
            _this.preloadScreenshotHeights(result);
        })
            .catch(function (response) {
            _this.hideProgressBar();
            _this.error =
                400 === response.status
                    ? _this.$tc("consents.error.invalid_" + _this.identifier.type)
                    : _this.$tc('errors.generic');
        });
    };
    ConsentListComponent.prototype.statusColor = function (status) {
        return STATUS_COLORS[status];
    };
    ConsentListComponent.prototype.stateDetail = function (state) {
        switch (state.status) {
            case 'granted':
                return this.$tc('consents.status_detail.granted', 1, {
                    date: this.formatDate(state.expiresAt)
                });
            case 'expired':
                return this.$tc('consents.status_detail.expired', 1, {
                    date: this.formatDate(state.expiresAt)
                });
            case 'withdrawn':
                return this.$tc('consents.status_detail.withdrawn', 1, {
                    date: this.formatDate(state.withdrawnAt)
                });
            default:
                return this.$tc('consents.status_detail.none');
        }
    };
    ConsentListComponent.prototype.brandRequirement = function (advertiser, index) {
        if (0 === index || undefined === advertiser.mandatory) {
            return null;
        }
        return advertiser.mandatory ? 'mandatory' : 'optional';
    };
    ConsentListComponent.prototype.sendingRows = function (lead) {
        var _this = this;
        if (this.result === null) {
            return [];
        }
        return this.result.advertisers.map(function (advertiser) { return ({
            advertiser: advertiser,
            channels: _this.visibleChannels
                .map(function (channel) { return ({
                channel: channel,
                status: lead.sendingStateFor(advertiser.id, channel).status
            }); })
                .filter(function (item) { return item.status !== 'none'; })
        }); });
    };
    ConsentListComponent.prototype.formatDateTime = function (date) {
        return moment(date).format('L LT');
    };
    ConsentListComponent.prototype.formatDate = function (date) {
        return date ? moment(date).format('L') : '';
    };
    ConsentListComponent.prototype.getSupportUrl = function (lead) {
        return lead.collect.getSupportUrl();
    };
    ConsentListComponent.prototype.preloadScreenshotHeights = function (result) {
        var _this = this;
        result.people.forEach(function (person) {
            person.leads.forEach(function (lead) {
                lead.collect.consents.forEach(function (consent) {
                    var url = consent.screenshotUrl;
                    if (!url || _this.imageHeights[url] !== undefined) {
                        return;
                    }
                    var img = new Image();
                    img.onload = function () {
                        _this.$set(_this.imageHeights, url, img.naturalHeight);
                    };
                    img.src = url;
                });
            });
        });
    };
    ConsentListComponent.prototype.isCropped = function (url) {
        return this.imageHeights[url] > CROP_HEIGHT_THRESHOLD;
    };
    ConsentListComponent.prototype.thumbnailStyle = function (url) {
        return this.isCropped(url) ? { backgroundImage: "url('" + url + "')" } : null;
    };
    __decorate([
        decorators_1.Container(config_1.default.REPOSITORY_CONSENT),
        __metadata("design:type", consent_repository_1.ConsentRepository)
    ], ConsentListComponent.prototype, "consentRepository", void 0);
    __decorate([
        layoutModule.Action('showProgressBar'),
        __metadata("design:type", Function)
    ], ConsentListComponent.prototype, "showProgressBar", void 0);
    __decorate([
        layoutModule.Action('hideProgressBar'),
        __metadata("design:type", Function)
    ], ConsentListComponent.prototype, "hideProgressBar", void 0);
    __decorate([
        vue_property_decorator_1.Watch('$route'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ConsentListComponent.prototype, "onRouteChange", null);
    ConsentListComponent = __decorate([
        vue_class_component_1.default({
            components: {
                CampaignTypeComponent: Type_vue_1.default,
                CampaignFlagComponent: Flag_vue_1.default,
                CampaignStateComponent: State_vue_1.default
            }
        })
    ], ConsentListComponent);
    return ConsentListComponent;
}(vue_1.default));
exports.default = ConsentListComponent;
